import FEHeaderProps from './props';
import style from './style.module.css';
import { Confirmation, Menu } from './components';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import StartAppConfirmation from './components/startAppConfirmation';
import FEMobileBar from 'ui-kit/components/FEMobileBar';

const FEMobileHeader = ({
  orderType,
  address,
  restaurant,
  bonusAccount,
  onAddressBarClick,
  onCloseConfirmation,
  onDeclineConfirmation,
  isOpenConfirmation,
  isOpenStartAppConfirmation
}: FEHeaderProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={clsx(style.dataSidePadding, style.dataSide)}>
        <div className={style.addressContainer}>
          <FEMobileBar
            onClick={onAddressBarClick}
            label={
              orderType === 'COURIER'
                ? t('cartography.header.deliveryLabel')
                : t('cartography.header.pickupLabel')
            }
            value={orderType === 'COURIER' ? address : restaurant}
            placeholder={t('cartography.header.placeholder')}
            theme='outline'
            color={'black'}
            isOpenStartAppConfirmation={isOpenStartAppConfirmation}
          />

          <Menu bonusAccount={bonusAccount} />

          <Confirmation
            value={orderType === 'COURIER' ? address : restaurant}
            open={isOpenConfirmation}
            onClose={onCloseConfirmation}
            onDeclineConfirmation={onDeclineConfirmation}
          />


        </div>
      </div>
      <StartAppConfirmation
        value={orderType === 'COURIER' ? address : restaurant}
        open={isOpenStartAppConfirmation}
        onClose={onCloseConfirmation}
        onDeclineConfirmation={onDeclineConfirmation}
      />
    </>
  );
};

export default FEMobileHeader;
export type { FEHeaderProps };
